import React from 'react'
import styled from '@emotion/styled'
import { spacing } from '@mobi/component-library/Theme/Common'
import { SummaryLine } from '@mobi/betslip/Components/Common/SummaryLine'
import { BetCard } from '@mobi/betslip/Components/Common/BetCard'
import { InlineAlert } from '@mobi/betslip/Components/Common/InlineAlert'
import type { KambiSportsShare } from '@core/Areas/ShareBet/types'
import { BetInfo } from '@core/Areas/KambiSports/Components/BetHistory/BetInfo'
import { formatDollarDecimalToThousandMultplier } from '@core/Areas/KambiSports/helpers/currencyFormat'
import { getKambiCouponBetStatus } from '@core/Areas/KambiSports/helpers/getKambiCouponBetStatus'

export const KambiSportsCouponShare: React.FC<{
  share: KambiSportsShare['share']
  isCostShared: boolean
}> = ({ share, isCostShared }) => {
  const bet = share.coupon.bets[0]
  const stake = bet?.stake
  const potentialPayout = bet?.potentialPayout
  const statusProps = getStatusProps(getKambiCouponBetStatus(bet))

  return (
    <BetCard.Container
      topComponent={
        statusProps ? (
          <InlineAlert
            type={statusProps.type}
            text={statusProps.text}
            hasIcon={false}
            isCenterAlign
          />
        ) : null
      }
    >
      <BetInfo historyCoupon={share.coupon} />

      {isCostShared && stake != null && (
        <InvestmentWrapperStyled>
          <SummaryLine
            testId='KambiShare.Stake'
            left='Stake'
            right={`$${formatDollarDecimalToThousandMultplier(stake)}`}
          />
          {potentialPayout != null && (
            <SummaryLine
              testId='KambiShare.PotentialPayout'
              left='Potential Payout'
              right={`$${formatDollarDecimalToThousandMultplier(potentialPayout)}`}
            />
          )}
        </InvestmentWrapperStyled>
      )}
    </BetCard.Container>
  )
}

// =============
// Local Helpers
// =============

function getStatusProps(
  status: ReturnType<typeof getKambiCouponBetStatus>
): Pick<React.ComponentProps<typeof InlineAlert>, 'text' | 'type'> | null {
  switch (status) {
    case 'Won':
      return { text: 'WINNER', type: 'success' }
    case 'NoPayout':
      return { text: 'NO PAYOUT', type: 'neutral' }
    case 'Pending':
      return { text: 'PENDING', type: 'warning' }
    default:
      return null
  }
}

// ======
// Styles
// ======

const InvestmentWrapperStyled = styled.div({
  display: 'flex',
  flexDirection: 'column',
  gap: spacing.smx2,
  marginTop: spacing.smx1,
})
